var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-add",on:{"click":function($event){return _vm.addMeal()}}},[_c('Icon',{attrs:{"icon":"fa fa-plus","text":"Ajouter un repas"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }